import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';

// View Imports
import Layout from './view/Layout';
import HomePage from './view/HomePage';
import ProfilePage from './view/ProfilePage';
import MyDownloads from './view/MyDownloads';
import AboutUs from './view/AboutUs';
import TermsAndConditions from './view/TermsAndConditions';
import FAQ from './view/FAQ';
import PrivacyPolicy from './view/PrivacyPolicy';
import RefundPolicy from './view/RefundPolicy';
import DeleteAccountPolicy from './view/DeleteAccountPolicy';
import Pricing from './view/Pricing';
import TemplateDetails from './view/TemplateDetails';
import CreditTransactions from './view/CreditTransactions';
import BuyCredits from './view/BuyCredits';
import PurchaseHistory from './view/PurchaseHistory';
import Notifications from './view/Notifications';
import Login from './view/Login'
import { AuthProvider } from './contexts/AuthContext';
import ProfileCompletion from './view/ProfileCompletion';
import { WalletProvider } from './contexts/WalletContext';
import { TemplateProvider } from './contexts/TemplateContext';
import SmartForm from './view/SmartForm';


/**
 * ProtectedRoute Component
 * Checks for access token in localStorage.
 * If not found, redirects to /login.
 */
const ProtectedRoute = () => {
  const token = localStorage.getItem('my_access_token');

  console.log("access token", token);

  // If no token, redirect to login page
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If token exists, render the child routes (Outlet)
  return <Outlet />;
};

function App() {
  return (
    <AuthProvider>
      <WalletProvider>
        <TemplateProvider>
          <Router>
            <Routes>
              {/* Public Route: Login is accessible to everyone */}
              <Route path="/login" element={<Login />} />

              {/* Public Website Routes */}
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="about-us" element={<AboutUs />} />
                <Route path="terms" element={<TermsAndConditions />} />
                <Route path="faq" element={<FAQ />} />
                <Route path="privacy" element={<PrivacyPolicy />} />
                <Route path="refund" element={<RefundPolicy />} />
                <Route path="delete" element={<DeleteAccountPolicy />} />
                <Route path="price" element={<Pricing />} />
                <Route path="template-details/:template_id" element={<TemplateDetails />} />
              </Route>

              {/* Protected Routes Wrapper: 
            Everything inside this Route requires 'my_access_token' 
        */}
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Layout />}>
                  {/* Other Authenticated Routes */}
                  <Route path="my-profile" element={<ProfilePage />} />
                  <Route path="download" element={<MyDownloads />} />
                  <Route path="credit-transactions" element={<CreditTransactions />} />
                  <Route path="plans" element={<BuyCredits />} />
                  <Route path="credit-purchases" element={<PurchaseHistory />} />
                  <Route path="notifications" element={<Notifications />} />
                  <Route path="/complete-profile" element={<ProfileCompletion />} />
                  <Route path="/smart-form/:template_id/create-entry" element={<SmartForm/>}/>

                </Route>
              </Route>

              {/* Catch-all Route: Redirect unknown URLs to Home or Login */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </TemplateProvider>
      </WalletProvider>
    </AuthProvider>
  );
}

export default App;